<form class="form-b4a" [formGroup]="form" (submit)="submit()">
  <span class="file-upload full-w" *ngIf="isBrandCategory">
    <span
      class="file-upload logo"
      [formGroupName]="shop"
      *ngFor="let shop of shops"
      [ngClass]="{ 'ng-invalid ng-dirty': invalidControl(shop, 'image') }"
    >
      <label [for]="'image_' + shop">
        <span>
          Logo principal da marca
          <ng-container *ngIf="isFieldRequired('image')"> *</ng-container>
          <small *ngIf="getDimensionHint(shop, 'image') as hint"
            >- {{ hint }}</small
          >
        </span>
        <img [src]="form?.value[shop]?.image || defaultImg" />
      </label>
      <span class="buttons" *ngIf="permission">
        <p-fileUpload
          mode="basic"
          chooseLabel="Selecionar"
          [auto]="true"
          [name]="'image_' + shop"
          [accept]="acceptedImageFormats"
          [maxFileSize]="maxImageFileSize"
          invalidFileSizeMessageSummary="Arquivo inválido"
          invalidFileSizeMessageDetail="O tamanho máximo permitido é 250kb."
          uploadIcon="pi pi-file"
          [customUpload]="true"
          (uploadHandler)="onShopImageUpload($event, shop, 'image')"
          [id]="'image_' + shop"
        />
        <p-button
          label="Utilizar em todas"
          severity="help"
          pTooltip="Utilizar esta imagem em todas as lojas"
          *ngIf="form?.value[shop]?.image && imageDiff('image')"
          (onClick)="copyImages('image', shop)"
        />
      </span>
      <small class="invalid-feedback" *ngIf="invalidControl(shop, 'image')">
        Obrigatório
      </small>
    </span>
  </span>
  <span class="file-upload full-w">
    <span
      class="file-upload logo"
      [formGroupName]="shop"
      *ngFor="let shop of shops"
      [ngClass]="{
        'ng-invalid ng-dirty': invalidControl(shop, 'brandBanner')
      }"
    >
      <label [for]="'brandBanner_' + shop">
        <span>
          Banner {{ getShop(shop)?.label }}
          <ng-container *ngIf="isFieldRequired('brandBanner')"> *</ng-container>
          <small *ngIf="getDimensionHint(shop, 'brandBanner') as hint"
            >- {{ hint }}</small
          >
        </span>
        <img [src]="form?.value[shop]?.brandBanner || defaultImg" />
      </label>
      <span class="buttons" *ngIf="permission">
        <p-fileUpload
          mode="basic"
          chooseLabel="Selecionar"
          [auto]="true"
          [name]="'brandBanner_' + shop"
          [accept]="acceptedImageFormats"
          [maxFileSize]="maxImageFileSize"
          invalidFileSizeMessageSummary="Arquivo inválido"
          invalidFileSizeMessageDetail="O tamanho máximo permitido é 250kb."
          uploadIcon="pi pi-file"
          [customUpload]="true"
          (uploadHandler)="onShopImageUpload($event, shop, 'brandBanner')"
          [id]="'brandBanner_' + shop"
        />
        <p-button
          label="Utilizar em todas"
          severity="help"
          pTooltip="Utilizar esta imagem em todas as lojas"
          *ngIf="form.value[shop]?.brandBanner && imageDiff('brandBanner')"
          (onClick)="copyImages('brandBanner', shop)"
        />
      </span>
      <small
        class="invalid-feedback"
        *ngIf="invalidControl(shop, 'brandBanner')"
      >
        Obrigatório
      </small>
    </span>
  </span>

  <div class="form-footer">
    <div class="info">
      <p-message
        *ngIf="missingImagesWarning"
        styleClass="category-missing-images-warning"
        severity="warn"
        [text]="missingImagesWarning"
      />
      <div *ngIf="category">
        <p>
          *Última alteração em:
          {{ category.updatedAt | date : 'short' }}
        </p>
        <p>{{ supportedFormatsInfo }}</p>
        <p>{{ maxFileSizeInfo }}</p>
        <p>{{ dimensionMarginInfo }}</p>
      </div>
    </div>
    <div class="action">
      <p-button
        *ngIf="permission"
        type="submit"
        pRipple
        label="Salvar"
        severity="primary"
        [disabled]="saveDisabled"
      />
    </div>
  </div>
</form>
